var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "page": "page"
    }
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("my_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('my_page.form_desc'))
    }
  }), _vm.getModuleConfig('my_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('my_page.content'))
    }
  }) : _vm._e(), _vm.showFilter ? _c('coupon-filters', {
    staticClass: "s-mb-3",
    attrs: {
      "options": _vm.filterOptions
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }) : _vm._e(), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading && _vm.currentData.coupons.length > 0 ? _vm._l(_vm.currentData.coupons, function (item, index) {
    return _c('coupon-card', {
      key: index,
      attrs: {
        "coupon": item,
        "buttonText": _vm.couponButtonText(item),
        "showCode": _vm.codeIsVisibleInList
      },
      on: {
        "exchange": _vm.showCouponModal
      }
    });
  }) : _c('coupon-empty'), _c('Pagination', {
    staticStyle: {
      "margin": "32px auto 50px"
    },
    attrs: {
      "total-page": _vm.currentData.meta.lastPage,
      "has-next": _vm.currentData.meta.hasNext
    },
    on: {
      "input": _vm.handlePageIsChanged
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 2), _c('coupon-modal', {
    ref: "couponModal",
    attrs: {
      "coupon": _vm.selectedCoupon,
      "usage-period-title": _vm.getModuleConfig('detail.usage_period_title'),
      "show-code": _vm.codeIsVisibleInDetail,
      "showQrcodeButton": _vm.showQrcodeButton
    },
    on: {
      "confirmed": _vm.refresh
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }